const INITIAL_STATE = {
  error: false,
  loading: false,
  data: [],
};

const reducerLanguage = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "LANGUAGE_REQUEST":
      return { loading: true, error: false, data: [] };
    case "LANGUAGE_ERROR":
      return { loading: false, error: true, data: [] };
    case "LANGUAGE_SUCCESS":
      return { loading: false, error: false, data: action.payload };
    default:
      return state;
  }
};

export default reducerLanguage;
